module.exports = __webpack_public_path__ + "static/media/sidebar-3.34535b95.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sidebar-3.jpg
// module id = 369
// module chunks = 0